module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/american-logo-5456fd270ee34231fd66bfdda903e043.svg";